import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_BASE_URL;
const accessToken = sessionStorage.getItem("accessToken");
const headers = accessToken ? { Authorization: accessToken } : {};

export const formatBytes = (bytes) => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const getDisplayFileName = (fileName) => {
  // Match and remove UUID-like string (hyphen followed by hex blocks) before extension
  return fileName.replace(
    /(-[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})(?=\.[^.\s]+$)/i,
    ""
  );
};

export const fetchAndDownloadFile = async (file) => {
  if (!file?.key || !file?.name) return;
  const encodedKey = encodeURIComponent(file.key);

  const toastId = toast.loading("File download in progress...", {
    theme: "colored",
  });

  try {
    const response = await fetch(
      `${baseUrl}/storage/file/download?key=${encodedKey}`,
      { headers }
    );

    if (!response.ok) throw new Error("File not found");

    const blob = await response.blob();
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = file.name;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(downloadLink.href);

    toast.update(toastId, {
      render: "File downloaded successfully",
      type: "success",
      autoClose: 3000,
      isLoading: false,
      closeButton: true,
    });
  } catch (error) {
    toast.update(toastId, {
      render: "Failed to download file",
      type: "error",
      isLoading: false,
      autoClose: 3000,
      closeButton: true,
    });
  }
};

export const fetchAndDownloadFileURL = async (fileUrl) => {
  if (!fileUrl) return;

  try {
    const response = await fetch(fileUrl);

    if (!response.ok) throw new Error("Download failed");

    const blob = await response.blob();
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileUrl;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(downloadLink.href);
  } catch (err) {
    console.log(err);
  }
};

export const normalizeType = (value) => value?.toString().trim().toUpperCase().replace(/\s+/g, "_");
